import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import s3 from "../assets/images/services/s3.png";
import punctual from "../assets/images_new/reliable-punctual.webp";
import happier from "../assets/images_new/happier.webp";
import cooperating from "../assets/images_new/cooperative-staff.webp";


const AirportServices = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={12} md={7}>
              <div className="contact-banner pt-60">
                <h4>AIRPORT TRANSFER SERVICE</h4>
                <p className="pr-50">
                  Owing to the hustle-bustle and crowded roads in the city, you may find it difficult to get around, especially if you have to catch a flight or attend an important meeting after a long flight. To provide a seamless and comfortable journey to and from the airport, Hive Employee Transportation And Cab Services provides a direct transfer to your destination. <br />
                  Backed by a team of well-trained and professional drivers, we aim to simplify your mobility needs. Be it a domestic or international flight or an important meeting after a flight, we make sure that you reach your destination on time, safe and sound. Sit back, relax and forget the hassle of driving around the city.
                </p>
              </div>
            </Col>
            <Col xs={12} md={5} className="pr-0">
              <img src={s3} className="img-fluid" alt=""></img>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row>
            <Col xs={12} md={12} data-aos="fade-up"
            >
              <div className="main-title text-center">
                <h4>
                  An elite way to airport travel
                </h4>
                <div className="divider-center"></div>
              </div>
            </Col>
          </Row>
          <Row className="mt-60">
            <Col xs={12} md={4} data-aos="fade-up"
            >
              <div className="service-cards pt-40">
                <img src={punctual} className="img-fluid" alt=""></img>
                <h6>PUNCTUAL AND COMFORTABLE</h6>
                <p>
                  Being one of the premier transportation service providers, we have been catering to quality airport transfers through our vast fleet of sedans, SUVs, mini-coaches, and vans. Our experienced and reliable drivers provide a safe and comfortable ride to and from the airport.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up"
            >
              <div className="service-cards pt-40">
                <img src={happier} className="img-fluid" alt=""></img>
                <h6>TRAVEL MADE EASIER AND HAPPIER</h6>
                <p>
                  We aim at achieving the highest possible standards for all our services. No matter if you’re heading to a corporate meeting in Hyderabad or you need to be dropped off at the domestic or international airport, Hive Employee Transportation And Cab Services will escort you to your destination relaxed and rejuvenated.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up"
            >
              <div className="service-cards pt-40">
                <img src={cooperating} className="img-fluid" alt=""></img>
                <h6>CORDIAL AND COOPERATIVE STAFF</h6>
                <p>
                  We offer car rental services—such as SUVs, sedans, and hatchbacks—to corporate clients. Additionally, we support chauffeur-driven cars for all your business needs. What makes us renowned in the industry is that all our vehicles comply with laws and regulations to cater to corporate services with an excellent track record.
                </p>
              </div>
            </Col>

            {/* <Col xs={12} md={4} data-aos="fade-up"
      >
                <div className="service-cards pt-40">
                  <img src={memorable} className="img-fluid" alt=""></img>
                  <h6>MEMORABLE EXPERIENCE</h6>
                  <p>
                  Recognized as a professional and reliable transportation service provider, we are ready to meet your requirements quickly and efficiently. You can go along with our state-of-the-art reputation combined with our world-class services, well-maintained vehicles, courteous drivers, and the 24/7 support system.


                  </p>
                </div>
              </Col>
   */}

          </Row>
        </Container>
      </div>
    </div>
  )
}

export default AirportServices